import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { ChatMessage } from '@mezha/api'
import type { Channel } from '../api/endpoints/social'

export type Connection = 'idle' | 'live' | 'lost'

export type Notice = { id: number; text: string }

type State = {
  connection: Connection
  lessMotion: boolean
  /** Unread chat messages per channel while the chat panel does not show it. */
  unread: Record<Channel, number>
  lastMessage: ChatMessage | null
  viewing: Channel | null
  notices: Notice[]
  /** Private chat partner (account id and name) opened from elsewhere. */
  dm: { id: number; name: string } | null
}

const readLessMotion = () => {
  try {
    return localStorage.getItem('mezha.lessMotion') === 'true'
  } catch {
    return false
  }
}

const initial: State = {
  connection: 'idle',
  lessMotion: readLessMotion(),
  unread: { place: 0, private: 0, clan: 0, system: 0 },
  lastMessage: null,
  viewing: null,
  notices: [],
  dm: null,
}

let noticeId = 0

export const ui = createSlice({
  name: 'ui',
  initialState: initial,
  reducers: {
    connection: (s, a: PayloadAction<Connection>) => {
      s.connection = a.payload
    },
    lessMotion: (s, a: PayloadAction<boolean>) => {
      s.lessMotion = a.payload
      try {
        localStorage.setItem('mezha.lessMotion', String(a.payload))
      } catch {
        /* private mode */
      }
    },
    chatArrived: (s, a: PayloadAction<{ channel: Channel; message: ChatMessage }>) => {
      s.lastMessage = a.payload.message
      if (s.viewing !== a.payload.channel) s.unread[a.payload.channel] += 1
    },
    chatViewing: (s, a: PayloadAction<Channel | null>) => {
      s.viewing = a.payload
      if (a.payload) s.unread[a.payload] = 0
    },
    notice: (s, a: PayloadAction<string>) => {
      s.notices.push({ id: ++noticeId, text: a.payload })
    },
    dropNotice: (s, a: PayloadAction<number>) => {
      s.notices = s.notices.filter(n => n.id !== a.payload)
    },
    openDm: (s, a: PayloadAction<{ id: number; name: string } | null>) => {
      s.dm = a.payload
    },
  },
})
